import React, { useContext } from 'react'
import { Grid, GridCell, Text, View } from 'oio-react'
import UserListItemTile from 'src/components/User/ListItemTile'
import { useUserList } from 'src/graphql/hooks'
import { InitiativeHierarchyContext } from 'src/libraries/contexts/InitiativeHierarchy'

const GroupPeopleBlock = () => {
   const { initiative } = useContext(InitiativeHierarchyContext)
   const { userList } = useUserList({
      userRelationshipFilter: {
         entityType: 'initiative',
         entityId: initiative.id,
         hasRoleParticipantElement: {
            roleType: 'primary',
            status: 'active'
         }
      },
      withRelationship: true,
      withRelationshipEntityType: 'initiative',
      withRelationshipEntityId: initiative.id
   })

   return (
      <View width="100%">
         {userList.items.length === 0 && (
            <View textAlign="center" padding="20px">
               <Text size="1.5">
                  {`No one in this ${initiative.type.nameSingular} to show yet`}
               </Text>
            </View>
         )}
         <Grid columns="1" spacing="30px">
            {userList.items.map(user => (
               <GridCell key={user.id}>
                  <UserListItemTile
                     id={user.id}
                     avatarMedia={user.avatarMedia}
                     fullName={user.fullName}
                     organization={user.organization}
                     position={user.position}
                  />
               </GridCell>
            ))}
         </Grid>
      </View>
   )
}

export default GroupPeopleBlock
